import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllofflineEvents } from '../../services/offlineEventApi';
import { update } from 'lodash';


// Async thunk for fetching events
export const fetchEvents = createAsyncThunk(
  'events/fetchEvents',
  async (params, { rejectWithValue }) => {
    try {
      const data = await getAllofflineEvents(params); 
      return data.response || [];
      
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const eventsSlice = createSlice({
  name: 'events',
  initialState: {
    events: [],
    loading: false,
    error: null,
  },
  reducers: {
    // You can add more reducers here if needed
    clearEvents: (state) => {
      state.events = [];
      state.error = null;
    },

    updateEvents: (state, action) => {
    //  console.log("updateEvents action payload", action.payload);
      const postIndex =   state?.events?.findIndex((event) => event._id === action.payload._id);
      if (postIndex !== -1) {
        state.events[postIndex] = action.payload;
      } else {
        state.events = [action.payload, ...state.events];
      }
     
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.events = action.payload;
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch events';
        state.events = [];
      });

  },
});

export const { clearEvents ,updateEvents } = eventsSlice.actions;
export default eventsSlice.reducer;
